import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	lockedLabel: {
		id: 'app.contentChip.lockedLabel',
		defaultMessage: 'Locked',
		description: 'Screen reader label for the lock badge on content that needs a subscription',
	},
	seconds: {
		id: 'app.contentChip.seconds',
		defaultMessage: '{value} sec',
		description: 'Content length under a minute, shown in the artwork chip, e.g. "53 sec"',
	},
	minutes: {
		id: 'app.contentChip.minutes',
		defaultMessage: '{value} min',
		description: 'Content length under an hour in whole minutes, shown in the artwork chip, e.g. "7 min"',
	},
	hoursAndMinutes: {
		id: 'app.contentChip.hoursAndMinutes',
		defaultMessage: '{hours}h {minutes}m',
		description: 'Content length of an hour or more with leftover minutes, shown in the artwork chip',
	},
	hours: {
		id: 'app.contentChip.hours',
		defaultMessage: '{hours}h',
		description: 'Content length of a whole number of hours, shown in the artwork chip',
	},
});
